import { Checkbox, Collapse, Form, Input, Select } from "antd";
import style from "./style.module.scss";
import { SimpleInput } from "../../../../../common/components/simpleInput";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useState } from "react";
import { InputSelect } from "../../../../../common/components/InputSelect/InputSelect";
import { RiDeleteBin5Line } from "react-icons/ri";
import { GlobalRequest } from "../../../../../common/services/request";
import { handleNumericDecimalInput } from "../../../../../common/utils/numericInputHandler";

type OperationBlockProps = {
    title?: string;
    prefix: "embarkation" | "debarkation";
    form: any;
    sectionErrors?: {
      embarkation?: boolean;
      debarkation?: boolean;
    };
    validationTick?: number;
    setVehicleExternalParts: React.Dispatch<React.SetStateAction<any[]>>;
    setVehicleInternalParts: React.Dispatch<React.SetStateAction<any[]>>;
  };

  export const OperationBlock = ({
    title,
    prefix,
    form,
    sectionErrors,
    validationTick,
    setVehicleExternalParts,
    setVehicleInternalParts,
  }: OperationBlockProps) => {

  const [vehicleExternalParts, setLocalVehicleExternalParts] = useState<any[]>([]);
  const [vehicleInternalParts, setLocalVehicleInternalParts] = useState<any[]>([]);

  /*const [sectionErrors, setSectionErrors] =  useState<{
    embarkation?: boolean;
    debarkation?: boolean;
  }>({}); */

  const [, forceRender] = useState(0);

  useEffect(() => {
    forceRender((prev) => prev + 1);
  }, [validationTick]);

  //////////////// ALL FUNCTION IN VEHICLE ///////////////////

  const getVehicleItems = async () => {
    const exterior = await GlobalRequest.get(
      "/api/vehicle_items/select?section=exterior"
    );
  
    const exteriorItems = exterior?.data?.member || [];
    setLocalVehicleExternalParts(exteriorItems); //not usefull 
    setVehicleExternalParts(exteriorItems);
  
    const interior = await GlobalRequest.get(
      "/api/vehicle_items/select?section=interior"
    );
  
    const interiorItems = interior?.data?.member || [];
    setLocalVehicleInternalParts(interiorItems);
    setVehicleInternalParts(interiorItems);
  };

  const getInspectionValues = (
    vehicleIndex: number,
    section: "EXTERIOR" | "INTERIOR"
  ) =>
    form.getFieldValue([
      prefix,
      "vehicles",
      vehicleIndex,
      "vehicleInspectionItems",
      section,
    ]) || {};

    const areAllInspectionItemsSelected = (
        vehicleIndex: number,
        section: "EXTERIOR" | "INTERIOR",
        itemsRef: any[]
      ) => {
        const values = getInspectionValues(vehicleIndex, section);
      
        return (
          itemsRef.length > 0 &&
          itemsRef.every((item: any) => !!values[item.id])
        );
      };

  const hasCollapseErrors = (namePath: (string | number)[]) => {
    return form.getFieldsError().some(({ name, errors }: any) => {
      return (
        errors.length > 0 &&
        namePath.every((part, index) => name[index] === part)
      );
    });
  };

  const handleSelectAllInspectionItems = (
    vehicleIndex: number,
    section: "EXTERIOR" | "INTERIOR",
    itemsRef: any[],
    checked: boolean
  ) => {
    const currentInspectionItems =
      form.getFieldValue([
        prefix,
        "vehicles",
        vehicleIndex,
        "vehicleInspectionItems",
      ]) || {};
  
    form.setFieldValue(
      [prefix, "vehicles", vehicleIndex, "vehicleInspectionItems"],
      {
        ...currentInspectionItems,
        [section]: itemsRef.reduce((acc: any, item: any) => {
          acc[item.id] = checked;
          return acc;
        }, {}),
      }
    );
  };

  const FILLED_STATUS = "/api/load_filling_statuses/FILLED";

  const EmptyItem = () => (
    <div className={style.operationBlock__form_first_content_item}></div>
  );
  
  const isFilled = (containerName: number) => {
    const field = form.getFieldValue([
      prefix,
      "containers",
      containerName,
      "loadFillingStatus",
    ]);
  
    return field?.value === FILLED_STATUS;
  };

  return (
    <>
      <div className={style.operationBlock__movement_container}>
        {title && (
            <p className={style.operationBlock__title}>{title}</p>
        )}

        {/* CONTENEURS */}
        <span className={style.operationBlock__subtitles_card}>Conteneurs</span>
        <br />


          <Form.List name={[prefix, "containers"]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => (
                  <div key={key}>
                    <div className={style.operationBlock__form_first_content}>
                    <Collapse
                      style={{
                        width: "100%",
                        marginBottom: "15px",
                        border: hasCollapseErrors([prefix, "containers", name])
                          ? "solid 1.5px #ff4d4f"
                          : undefined,
                      }}
                      //ghost
                      items={[
                        {
                          key: "1",
                          label: "Informations du conteneur",
                          children: (
                            <div>
                              <div className={style.operationBlock__form_first_content}>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "reference"]}
                                    label="N° conteneur"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Champ requis",
                                      },
                                    ]}
                                    customInput={<Input />}
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "containerType"]}
                                    label="Type"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Champ requis",
                                      },
                                    ]}
                                    customInput={
                                      <InputSelect
                                        onChange={() => {}}
                                        uri="/api/container_types/select"
                                        style={{ minWidth: "125%" }}
                                        //params={{ itemsPerPage: 99999 }}
                                      />
                                    }
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "netWeight"]}
                                    label="Poids net"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Champ requis",
                                      },
                                    ]}
                                    customInput={
                                      <Input
                                        onKeyDown={handleNumericDecimalInput}
                                      />
                                    }
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "tareWeight"]}
                                    label="Tare"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Champ requis",
                                      },
                                    ]}
                                    customInput={
                                      <Input
                                        onKeyDown={handleNumericDecimalInput}
                                      />
                                    }
                                  />
                                </div>
                              </div>
                              <Form.Item noStyle shouldUpdate>
                                {() => {
                                  const additionalSealNumbersPath = [
                                    prefix,
                                    "containers",
                                    name,
                                    "additionalSealNumbers",
                                  ];

                                  const rawAdditionalSealNumbers = form.getFieldValue(
                                    additionalSealNumbersPath
                                  );

                                  const additionalSealNumbers = Array.isArray(rawAdditionalSealNumbers)
                                    ? rawAdditionalSealNumbers
                                    : [];

                                  const filled = isFilled(name);

                                  const addSealNumber = () => {
                                    const currentValue = form.getFieldValue(additionalSealNumbersPath);

                                    const normalizedValues = Array.isArray(currentValue)
                                      ? currentValue.map((value) => (typeof value === "string" ? value : ""))
                                      : [];

                                    /*
                                    * First extra field is already visible.
                                      If missing from the array, initialize index 0 before adding the new index.
                                    */
                                    const currentWithFirstField =
                                      normalizedValues.length > 0 ? normalizedValues : [""];

                                    form.setFieldValue(additionalSealNumbersPath, [
                                      ...currentWithFirstField,
                                      "",
                                    ]);
                                  };

                                  const removeSealNumber = (sealIndex: number) => {
                                    const current =
                                      form.getFieldValue(additionalSealNumbersPath) || [];
                                  
                                    const updated = current.filter(
                                      (_: any, index: number) => index !== sealIndex
                                    );
                                  
                                    form.setFieldValue(
                                      additionalSealNumbersPath,
                                      updated
                                    );
                                  };

                                  return (
                                    <>
                                      {/* DEUXIÈME LIGNE */}
                                      <div className={style.operationBlock__form_first_content}>
                                        {/* Etat */}
                                        <div className={style.operationBlock__form_first_content_item}>
                                          <SimpleInput
                                            Form={Form}
                                            name={[name, "loadFillingStatus"]}
                                            label="Etat"
                                            rules={[
                                              {
                                                required: true,
                                                message: "Ce champ est obligatoire",
                                              },
                                            ]}
                                            customInput={
                                              <InputSelect
                                                uri="/api/load_filling_status/select"
                                                onChange={(value) => {
                                                  form.setFieldValue(
                                                    [prefix, "containers", name, "loadFillingStatus"],
                                                    value
                                                  );

                                                  /*
                                                  * Clear additional numbers when state changes.
                                                  */
                                                  form.setFieldValue(additionalSealNumbersPath, []);

                                                  /*
                                                  * [Validation]: clears "required" error
                                                  */
                                                  form.validateFields([
                                                    [prefix, "containers", name, "loadFillingStatus"],
                                                  ]);
                                                }}
                                              />
                                            }
                                          />
                                        </div>

                                        {/* N° Plomb principal */}
                                        {filled ? (
                                          <>
                                            <div className={style.operationBlock__form_first_content_item}>
                                              <SimpleInput
                                                Form={Form}
                                                name={[name, "sealNumber"]}
                                                label="N° Plomb"
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: "Ce champ est obligatoire",
                                                  },
                                                ]}
                                                customInput={<Input />}
                                              />
                                            </div>
                                            <EmptyItem />
                                            <EmptyItem />
                                          </>
                                        ) : (
                                          <>
                                            <EmptyItem />
                                            <EmptyItem />
                                            <EmptyItem />
                                          </>
                                        )}
                                      </div>

                                      {/* CORRECTION */}
                                      {filled && (
                                        <>
                                          <div className={style.operationBlock__form_first_content}>
                                            <div
                                              key={key}
                                              className={style.operationBlock__form_first_content_item}
                                              style={{ maxHeight: "59px" }}
                                            >
                                              <span className={style.operationBlock__label}>
                                                N° Plomb supplémentaire
                                              </span>

                                              <Form.Item
                                                name={[name, "additionalSealNumbers", 0]}
                                                normalize={(value) =>
                                                  typeof value === "string" ? value : ""
                                                }
                                              >
                                                <Input />
                                              </Form.Item>
                                            </div>
                                            <div className={style.operationBlock__form_first_content_item}>
                                              <button
                                                className={style.operationBlock__add_btn}
                                                style={{ marginTop: "2.8vh" }}
                                                type="button"
                                                onClick={addSealNumber}
                                              >
                                                Ajouter N° Plomb
                                              </button>
                                            </div>
                                            <EmptyItem />
                                            <EmptyItem />
                                          </div>
                                          {filled &&
                                            additionalSealNumbers.slice(1).map((_, index) => {
                                              const sealIndex = index + 1;

                                              return (
                                                <div
                                                  key={`additional-seal-row-${sealIndex}`}
                                                  className={style.operationBlock__form_additional_seal_line}
                                                >
                                                  <div className={style.operationBlock__form_additional_seal}>
                                                    <Form.Item
                                                      name={[name, "additionalSealNumbers", sealIndex]}
                                                      normalize={(value) =>
                                                        typeof value === "string" ? value : ""
                                                      }
                                                    >
                                                      <Input />
                                                    </Form.Item>
                                                  </div>

                                                  <div className={style.operationBlock__form_additional_seal}>
                                                    <RiDeleteBin5Line
                                                      className={style.operationBlock__delete_additional_seal}
                                                      style={{ marginTop: "5px", marginLeft: 0 }}
                                                      title="Supprimer"
                                                      onClick={() => removeSealNumber(sealIndex)}
                                                    />                                             
                                                  </div>
                                                  <EmptyItem />
                                                  <EmptyItem />
                                                </div>
                                              );
                                            })}
                                        </>
                                      )}
                                    </>
                                  );
                                }}
                              </Form.Item>
                              <Form.Item
                                  noStyle
                                  shouldUpdate={(prev, curr) =>
                                    prev.containers?.[name]
                                      ?.loadFillingStatus !==
                                    curr.containers?.[name]?.loadFillingStatus
                                  }
                                >
                                  {() => {
                                    const field = form.getFieldValue([
                                      prefix,
                                      "containers",
                                      name,
                                      "loadFillingStatus",
                                    ]);

                                    const filled =
                                      field?.value ===
                                      "/api/load_filling_statuses/FILLED";

                                    if (!filled) return null;

                                    return (
                                      <div className={style.operationBlock__form_first_content}>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "goodsDescription"]}
                                    label="Disant contenir"
                                    customInput={
                                      <TextArea style={{ height: "60px" }} />
                                    }
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                ></div>
                              </div>
                                    );
                                  }}
                                </Form.Item>
                            </div>
                          ),
                          extra: (
                            <RiDeleteBin5Line
                              className={style.operationBlock__delete_icon}
                              style={{ marginTop: 0, marginLeft: "8px" }}
                              title="Supprimer"
                              onClick={() => remove(name)}
                            />
                          ),
                        },
                      ]}
                      defaultActiveKey={["1"]}
                      size="small"
                    />
                    </div>
                  </div>
                ))}

                <button
                  className={style.operationBlock__add_btn}
                  type="button"
                  onClick={() => add()}
                >
                  Ajouter
                </button>
              </>
            )}
          </Form.List>

          <br />
          <hr style={{ width: "95%", marginLeft: "10px" }} />
          <br />
        

          {/** FIN CONTENEURS */}

          {/* SACHERIE */}
          <span className={style.operationBlock__subtitles_card}>Sacherie</span>
          <br />

          <Form.List name={[prefix, "bags"]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name }) => (
                <div key={key}>
                  <div className={style.operationBlock__form_first_content}>
                    <Collapse
                    style={{
                      width: "100%",
                      marginBottom: "15px",
                      border: hasCollapseErrors([prefix, "bags", name])
                      ? "solid 1.5px #ff4d4f"
                      : undefined,
                    }}                      
                    items={[
                        {
                          key: "1",
                          label: "Informations des sacs",
                          children: (
                            <div>
                              <div className={style.operationBlock__form_first_content}>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "designation"]}
                                    label="Désignation"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Champ requis",
                                      },
                                    ]}
                                    customInput={<Input />}
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "batchNumber"]}
                                    label="Numéro de Lot"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Champ requis",
                                      },
                                    ]}
                                    customInput={<Input />}
                                  />
                                </div>

                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "tonnage"]}
                                    label="Tonnage"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Champ requis",
                                      },
                                    ]}
                                    customInput={
                                      <Input
                                        onKeyDown={handleNumericDecimalInput}
                                      />
                                    }
                                  />
                                </div>

                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "unitWeight"]}
                                    label="Poids unitaire (T)"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Champ requis",
                                      },
                                    ]}
                                    customInput={
                                      <Input
                                        onKeyDown={handleNumericDecimalInput}
                                      />
                                    }
                                  />
                                </div>
                                </div>
                                <div className={style.operationBlock__form_first_content}>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "content"]}
                                    label="Contenu"
                                    customInput={<Input />}
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "brand"]}
                                    label="Marque"
                                    customInput={<Input />}
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "packaging"]}
                                    label="Type de sac"
                                    customInput={<Input />}
                                  />
                                </div>

                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "qty"]}
                                    label="Quantité"
                                    customInput={
                                      <Input
                                        onKeyDown={handleNumericDecimalInput}
                                      />
                                    }
                                  />
                                </div>
                              
                            </div>
                            </div>
                          ),
                          extra: (
                            <RiDeleteBin5Line
                              className={style.operationBlock__delete_icon}
                              style={{ marginTop: 0, marginLeft: "8px" }}
                              title="Supprimer"
                              onClick={() => remove(name)}
                            />
                          ),
                        },
                      ]}
                      defaultActiveKey={["1"]}
                      size="small"
                    />
                  </div>
                </div>
              ))}

              <button
                className={style.operationBlock__add_btn}
                type="button"
                onClick={() => add()}
              >
                Ajouter
              </button>
            </>
          )}
          </Form.List>
          <br />
          <hr style={{ width: "95%", marginLeft: "10px" }} />
          <br />

          {/** FIN SACHERIE */}

          {/* VEHICILES */}
          <span className={style.operationBlock__subtitles_card}>Véhicules</span>
          <br />

          <Form.List name={[prefix, "vehicles"]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name }) => (
                <div key={key}>
                  <div className={style.operationBlock__form_first_content}>
                    <Collapse
                      style={{
                        width: "100%",
                        marginBottom: "15px",
                        border: hasCollapseErrors([prefix, "vehicles", name])
                          ? "solid 1.5px #ff4d4f"
                          : undefined,
                      }}
                      items={[
                        {
                          key: "1",
                          label: "Informations du véhicule",
                          children: (
                            <div>
                              <div className={style.operationBlock__form_first_content}>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[
                                      name,
                                      "registrationNumber",
                                    ]}
                                    label="N° d'immatriculation"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Champ requis",
                                      },
                                    ]}
                                    customInput={<Input />}
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "serialNumber"]}
                                    label="N° de châssis"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Champ requis",
                                      },
                                    ]}
                                    customInput={<Input />}
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "operational"]}
                                    label="Operationnel"
                                    customInput={
                                      <Select
                                        //style={{ width: 120 }}
                                        options={[
                                          { value: true, label: "EN ETAT DE MARCHE" },
                                          { value: false, label: "NON EN ETAT DE MARCHE" },
                                        ]}
                                      />
                                    }
                                  />
                                </div>
                                <div
                                  className={`${style.operationBlock__form_first_content_item}`}
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: 10,
                                  }}
                                >
                                  <div style={{ flex: 1 / 2 }}>
                                    <SimpleInput
                                      Form={Form}
                                      name={[name, "brand"]}
                                      label="Marque"
                                      customInput={<Input />}
                                    />
                                  </div>
                                  <div style={{ flex: 1 / 2 }}>
                                    <SimpleInput
                                      Form={Form}
                                      name={[name, "model"]}
                                      label="Modèle"
                                      customInput={<Input />}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className={style.operationBlock__form_first_content}>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "fuelType"]}
                                    label="Type de carburant"
                                    customInput={
                                      <Select
                                        options={[
                                          { value: "ESSENCE", label: "ESSENCE" },
                                          { value: "DIESEL", label: "DIESEL" },
                                          { value: "Autres", label: "Autres" },
                                        ]}
                                      />
                                    }
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: 10,
                                  }}
                                >
                                  <Form.Item noStyle shouldUpdate>
                                    {() => {
                                      const hasFuel = form.getFieldValue([
                                        prefix,
                                        "vehicles",
                                        name,
                                        "hasFuel",
                                      ]);

                                      return (
                                        <>
                                          <div style={{ flex: hasFuel === true ? 1 / 2 : 1 }}>
                                            <SimpleInput
                                              Form={Form}
                                              name={[name, "hasFuel"]}
                                              label="Carburant"
                                              customInput={
                                                <Select
                                                  allowClear
                                                  options={[
                                                    { value: true, label: "AVEC CARBURANT" },
                                                    { value: false, label: "SANS CARBURANT" },
                                                  ]}
                                                />
                                              }
                                            />
                                          </div>

                                          {hasFuel === true && (
                                            <div style={{ flex: 1 / 2 }}>
                                              <SimpleInput
                                                Form={Form}
                                                name={[name, "fuelLevel"]}
                                                label="Niveau carburant"
                                                customInput={<Input />}
                                              />
                                            </div>
                                          )}
                                        </>
                                      );
                                    }}
                                  </Form.Item>
                                </div>

                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "tonnage"]}
                                    label="Tonnage"
                                    customInput={
                                      <Input
                                        onKeyDown={handleNumericDecimalInput}
                                      />
                                    }
                                  />
                                </div>
                                <div
                                  className={`${style.operationBlock__form_first_content_item}`}
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: 10,
                                  }}
                                >
                                  <div style={{ flex: 1 / 3 }}>
                                    <SimpleInput
                                      Form={Form}
                                      name={[name, "length"]}
                                      label="Longueur"
                                      helperText="En mètres"
                                      customInput={
                                        <Input
                                          onKeyDown={handleNumericDecimalInput}
                                        />
                                      }
                                    />
                                  </div>
                                  <div style={{ flex: 1 / 3 }}>
                                    <SimpleInput
                                      Form={Form}
                                      name={[name, "width"]}
                                      label="Largeur"
                                      helperText="En mètres"
                                      customInput={
                                        <Input
                                          onKeyDown={handleNumericDecimalInput}
                                        />
                                      }
                                    />
                                  </div>
                                  <div style={{ flex: 1 / 3 }}>
                                    <SimpleInput
                                      Form={Form}
                                      name={[name, "height"]}
                                      label="Hauteur"
                                      helperText="En mètres"
                                      customInput={
                                        <Input
                                          onKeyDown={handleNumericDecimalInput}
                                        />
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ),
                          extra: (
                            <RiDeleteBin5Line
                              className={style.operationBlock__delete_icon}
                              style={{ marginTop: 0, marginLeft: "8px" }}
                              title="Supprimer"
                              onClick={() => remove(name)}
                            />
                          ),
                        },
                        {
                          key: "2",
                          label: "Extérieur",
                          children: (
                            <div className={style.operationBlock__checkbox_group}>
                              {vehicleExternalParts.map((v: any) => (
                                <Form.Item
                                key={v.id}
                                name={[
                                  name,
                                  "vehicleInspectionItems",
                                  "EXTERIOR",
                                  v.id,
                                ]}
                                valuePropName="checked"
                                className={style.operationBlock__checkbox_item}
                              >
                                <Checkbox>{v?.name}</Checkbox>
                              </Form.Item>
                              ))}
                            </div>
                          ),
                          extra: (
                            <div
                              onClick={(e) => e.stopPropagation()}
                              onMouseDown={(e) => e.stopPropagation()}
                              className={style.operationBlock__checkbox_item}
                            >
                              <Form.Item noStyle shouldUpdate>
                                {() => {
                                  const allSelected = areAllInspectionItemsSelected(
                                    name,
                                    "EXTERIOR",
                                    vehicleExternalParts
                                  );

                                  return (
                                    <Checkbox
                                      checked={allSelected}
                                      onChange={(e) =>
                                        handleSelectAllInspectionItems(
                                          name,
                                          "EXTERIOR",
                                          vehicleExternalParts,
                                          e.target.checked
                                        )
                                      }
                                    >
                                      Tout sélectionner
                                    </Checkbox>
                                  );
                                }}
                              </Form.Item>
                            </div>
                          ),
                        },
                        {
                          key: "3",
                          label: "Intérieur",
                          children: (
                            <div className={style.operationBlock__checkbox_group}>
                              {vehicleInternalParts.map((v: any) => (
                                <>
                                  <Form.Item
                                    key={v.id}
                                    name={[
                                        name,
                                        "vehicleInspectionItems",
                                        "INTERIOR",
                                        v.id,
                                    ]}
                                    valuePropName="checked"
                                    className={style.operationBlock__checkbox_item}
                                    >
                                    <Checkbox>{v?.name}</Checkbox>
                                    </Form.Item>
                                </>
                              ))}
                            </div>
                          ),
                          extra: (
                            <div
                              onClick={(e) => e.stopPropagation()}
                              onMouseDown={(e) => e.stopPropagation()}
                              className={style.operationBlock__checkbox_item}
                            >
                              <Form.Item noStyle shouldUpdate>
                                {() => {
                                  const allSelected = areAllInspectionItemsSelected(
                                    name,
                                    "INTERIOR",
                                    vehicleInternalParts
                                  );

                                  return (
                                    <Checkbox
                                      checked={allSelected}
                                      onClick={(e) => e.stopPropagation()}
                                      onChange={(e) =>
                                        handleSelectAllInspectionItems(
                                          name,
                                          "INTERIOR",
                                          vehicleInternalParts,
                                          e.target.checked
                                        )
                                      }
                                    >
                                      Tout sélectionner
                                    </Checkbox>
                                  );
                                }}
                              </Form.Item>
                            </div>
                          ),
                        },
                      ]}
                      defaultActiveKey={["1"]}
                      size="small"
                    />
                  </div>
                </div>
              ))}

              <button
                className={style.operationBlock__add_btn}
                type="button"
                onClick={() => {
                  add();
                  getVehicleItems();
                }}
              >
                Ajouter
              </button>
            </>
          )}
          </Form.List>
          <br />
          <hr style={{ width: "95%", marginLeft: "10px" }} />
          <br />

          {/** FIN VEHICLES */}

          {/* NAVIRES */}
          <span className={style.operationBlock__subtitles_card}>Navires</span>
          <br />

          <Form.List name={[prefix, "crafts"]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name }) => (
                <div key={key}>
                  <div className={style.operationBlock__form_first_content}>
                    <Collapse
                      style={{
                        width: "100%",
                        marginBottom: "15px",
                        border: hasCollapseErrors([prefix, "crafts", name])
                          ? "solid 1.5px #ff4d4f"
                          : undefined,
                      }}
                      items={[
                        {
                          key: "1",
                          label: "Informations du navire",
                          children: (
                            <div>
                              <div className={style.operationBlock__form_first_content}>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "name"]}
                                    label="Nom"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Champ requis",
                                      },
                                    ]}
                                    customInput={<Input />}
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "craftType"]}
                                    label="Type de navire"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Champ requis",
                                      },
                                    ]}
                                    customInput={
                                      <InputSelect
                                        onChange={() => {}}
                                        uri="/api/craft_types/select"
                                      />
                                    }
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "className"]}
                                    label="Classe"
                                    customInput={<Input maxLength={25}/>}
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: 10,
                                  }}
                                >
                                  <div style={{flex: 1/2}}>
                                    <SimpleInput
                                      Form={Form}
                                      name={[name, "engineType"]}
                                      label="Type de moteur"
                                      customInput={<Input />}
                                    />
                                  </div>
                                  <div style={{flex: 1/2}}>
                                    <SimpleInput
                                      Form={Form}
                                      name={[name, "craftPosition"]}
                                      label="Emplacement"
                                      customInput={
                                        <InputSelect
                                        onChange={() => {}}
                                        uri="/api/craft_positions/select"
                                      />
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className={style.operationBlock__form_first_content}>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "engineBrand"]}
                                    label="Marque"
                                    customInput={<Input />}
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "hasFuel"]}
                                    label="Carburant"
                                    customInput={
                                      <Select
                                        options={[
                                          { value: true, label: "AVEC CARBURANT" },
                                          { value: false, label: "SANS CARBURANT" },
                                        ]}
                                      />
                                    }
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "tonnage"]}
                                    label="Tonnage"
                                    customInput={
                                      <Input
                                        onKeyDown={handleNumericDecimalInput}
                                      />
                                    }
                                  />
                                </div>
                                <div
                                  className={`${style.operationBlock__form_first_content_item}`}
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: 10,
                                  }}
                                >
                                  <div style={{ flex: 1 / 3 }}>
                                    <SimpleInput
                                      Form={Form}
                                      name={[name, "length"]}
                                      label="Longueur"
                                      helperText="En mètres"
                                      customInput={<Input onKeyDown={handleNumericDecimalInput}/>}
                                    />
                                  </div>
                                  <div style={{ flex: 1 / 3 }}>
                                    <SimpleInput
                                      Form={Form}
                                      name={[name, "width"]}
                                      label="Largeur"
                                      helperText="En mètres"
                                      customInput={<Input onKeyDown={handleNumericDecimalInput}/>}
                                    />
                                  </div>
                                  <div style={{ flex: 1 / 3 }}>
                                    <SimpleInput
                                      Form={Form}
                                      name={[name, "height"]}
                                      label="Hauteur"
                                      helperText="En mètres"
                                      customInput={<Input onKeyDown={handleNumericDecimalInput}/>}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className={style.operationBlock__form_first_content}>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "observations"]}
                                    label="Observations"
                                    customInput={
                                      <TextArea style={{ height: "60px" }} />
                                    }
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                ></div>
                              </div>
                            </div>
                          ),
                          extra: (
                            <RiDeleteBin5Line
                              className={style.operationBlock__delete_icon}
                              style={{ marginTop: 0, marginLeft: "8px" }}
                              title="Supprimer"
                              onClick={() => remove(name)}
                            />
                          ),
                        },
                      ]}
                      defaultActiveKey={["1"]}
                      size="small"
                    />
                  </div>
                </div>
              ))}

              <button
                className={style.operationBlock__add_btn}
                type="button"
                onClick={() => add()}
              >
                Ajouter
              </button>
            </>
          )}
          </Form.List>
          <br />
          <hr style={{ width: "95%", marginLeft: "10px" }} />
          <br />

          {/** FIN NAVIRES */}

          {/* AUTRES */}
          <span className={style.operationBlock__subtitles_card}>Conventionnels</span>
          <br />

          <Form.List name={[prefix, "others"]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name }) => (
                <div key={key}>
                  <div className={style.operationBlock__form_first_content}>
                    <Collapse
                      style={{
                        width: "100%",
                        marginBottom: "15px",
                        border: hasCollapseErrors([prefix, "others", name])
                          ? "solid 1.5px #ff4d4f"
                          : undefined,
                      }}
                      items={[
                        {
                          key: "1",
                          label: "Informations de la cargaison",
                          children: (
                            <div>
                              <div className={style.operationBlock__form_first_content}>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "label"]}
                                    label="Label"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Champ requis",
                                      },
                                    ]}
                                    customInput={<Input />}
                                  />
                                </div>
                                <div
                                  className={`${style.operationBlock__form_first_content_item}`}
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: 10,
                                  }}
                                >
                                  <div style={{ flex: 3 / 5 }}>
                                    <SimpleInput
                                      Form={Form}
                                      name={[name, "quantity"]}
                                      label="Quantité"
                                      rules={[
                                        {
                                          required: true,
                                          message: "Champ requis",
                                        },
                                      ]}
                                      customInput={<Input onKeyDown={handleNumericDecimalInput}/>}
                                    />
                                  </div>
                                  <div style={{ flex: 2 / 5 }}>
                                    <SimpleInput
                                      Form={Form}
                                      name={[name, "unit"]}
                                      label="Unité"
                                      rules={[
                                        {
                                          required: true,
                                          message: "Champ requis",
                                        },
                                      ]}
                                      customInput={<Input />}
                                    />
                                  </div>
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "tonnage"]}
                                    label="Tonnage"
                                    customInput={
                                      <Input
                                        onKeyDown={handleNumericDecimalInput}
                                      />
                                    }
                                  />
                                </div>
                                {window.innerWidth > 1024 && (
                                  <>
                                    <div
                                      className={
                                        style.operationBlock__form_first_content_item
                                      }
                                    ></div>
                                  </>
                                )}
                              </div>
                              <div className={style.operationBlock__form_first_content}>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                >
                                  <SimpleInput
                                    Form={Form}
                                    name={[name, "description"]}
                                    label="Déscription"
                                    customInput={
                                      <TextArea style={{ height: "60px" }} />
                                    }
                                  />
                                </div>
                                <div
                                  className={
                                    style.operationBlock__form_first_content_item
                                  }
                                ></div>
                              </div>
                            </div>
                          ),
                          extra: (
                            <RiDeleteBin5Line
                              className={style.operationBlock__delete_icon}
                              style={{ marginTop: 0, marginLeft: "8px" }}
                              title="Supprimer"
                              onClick={() => remove(name)}
                            />
                          ),
                        },
                      ]}
                      defaultActiveKey={["1"]}
                      size="small"
                    />
                  </div>
                </div>
              ))}

              <button
                className={style.operationBlock__add_btn}
                type="button"
                onClick={() => add()}
              >
                Ajouter
              </button>
            </>
          )}
          </Form.List>

        </div>
        {sectionErrors?.[prefix] && (
          <span style={{ color: "#ff4d4f", marginLeft: "10px" }}>
            Veuillez remplir la section ci-dessus.
          </span>
        )}
    </>
  );
};
